import React, {useEffect, useMemo} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from '../../../_redux/invoices/invoicesActions';
import {Modal} from "react-bootstrap";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";
import {useInvoicesUIContext} from "../InvoicesUIContext";
import {DeleteInvoice} from "../../../_redux/invoices/invoicesCrud";

export function InvoiceDeleteDialog({id, show, onHide}) {
    const invoicesUIContext = useInvoicesUIContext();
    const invoicesUIProps = useMemo(() => {
        return {
            setIds: invoicesUIContext.setIds,
            queryParams: invoicesUIContext.queryParams
        }
    }, [invoicesUIContext]);


    const dispatch = useDispatch();
    const {isLoading} = useSelector(
        (state) => ({isLoading: state.invoices.actionsLoading}),
        shallowEqual
    );

    useEffect(() => {
        if (!id)
            onHide();
    }, [id]);

    useEffect(() => {}, [isLoading, dispatch]);

    const DeleteInvoice = () => {
        dispatch(actions.deleteInvoice(id)).then(() => {
            dispatch(actions.fetchInvoices(invoicesUIProps.queryParams));

            invoicesUIProps.setIds([]);

            onHide();
        })
    }


    return(
        <Modal
            show={show}
            onHide={onHide}
        >
            {isLoading && <ModalProgressBar variant={"query"}/> }

            <Modal.Header closeButton>
                <Modal.Title>
                    حذف فاتور
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isLoading && (
                    <span>آیا از حذف فاکتور انتخاب شده مطمئن هستید؟</span>
                )}
                {isLoading && <span>در حال حذف فاکتور...</span>}
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn btn-light btn-elevate"
                    >
                        لغو
                    </button>
                    <> </>
                    <button
                        type="button"
                        onClick={DeleteInvoice}
                        className="btn btn-delete btn-elevate"
                    >
                        تایید
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}